import React, {useState} from "react";
import { CustomInput, FormGroup, Label} from 'reactstrap';
import useGlobal from "../utils/globalStore";

function CovidStep2(props) {
    // eslint-disable-next-line
    const [globalState, globalActions] = useGlobal();
    const answers = globalState.answers;

    const [localStateSymptoms, updateSymptoms] = useState(answers.symptomsYesNo);

    const localOnChange = (event) => {
        updateSymptoms(event.target.value);
        props.handleChange(event);
    }

    return (
        <div>
            <h4>COVID Symptoms</h4>
            <hr className="my-2"  />
            <FormGroup>
                <Label for="symptomsYesNo">3. Are you currently experiencing fever (100.4 F or greater) or chills; cough; shortness of breath or difficulty breathing; fatigue; muscle or body aches; headache; new loss of taste or smell; sore throat; congestion or runny nose; nausea or vomiting; or diarrhea?</Label>

                <div >
                    <CustomInput type="radio" id="symptomsYes" label="Yes"
                                 name="symptomsYesNo"
                                 checked={localStateSymptoms === 'symptomsYes' }
                                 value="symptomsYes"
                                 onChange={localOnChange}
                    />
                    <CustomInput type="radio" id="symptomsNo" label="No"
                                 name="symptomsYesNo"
                                 checked={localStateSymptoms === 'symptomsNo' }
                                 value="symptomsNo"
                                 onChange={localOnChange}
                    />
                </div>
            </FormGroup>


        </div>

    );
}

export default CovidStep2;